// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__y+nAP","closeIcon":"CloseButton_closeIcon__NVpNU"};